import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import mariaAvatar from "../../assets/maria-m-avatar.jpeg";

const HomeIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const CalendarIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const ChartIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
  </svg>
);

const ProfileIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

export default function AppBottomNav() {
  const location = useLocation();
  const isHome = location.pathname === "/app/home" || location.pathname === "/app";

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#ECE7FA] bg-white/95 backdrop-blur-md shadow-[0_-4px_25px_rgba(0,0,0,0.05)]"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      aria-label="Navegação principal da área logada"
    >
      <div className="mx-auto max-w-md md:max-w-xl lg:max-w-2xl px-2">
        <div className="grid grid-cols-5 gap-1 py-1.5">
          {/* 1. Início */}
          <NavLink
            to="/app/home"
            end
            className={({ isActive }) =>
              [
                "relative flex min-h-[58px] flex-col items-center justify-center gap-1 rounded-2xl px-1 py-1 transition-all duration-200 active:scale-95",
                isActive
                  ? "font-extrabold text-[#5B38C2] bg-purple-50"
                  : "font-semibold text-gray-500 hover:text-[#5B38C2] hover:bg-purple-50/50",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <div className={`w-8 h-8 rounded-xl flex items-center justify-center transition-all ${isActive ? "bg-purple-100 shadow-2xs" : ""}`}>
                  <HomeIcon className={`h-5 w-5 ${isActive ? "text-[#5B38C2]" : "text-gray-500"}`} />
                </div>
                <span className="text-[10px] leading-none tracking-tight">Início</span>
              </>
            )}
          </NavLink>

          {/* 2. Rotina */}
          <NavLink
            to="/app/routine"
            className={({ isActive }) =>
              [
                "relative flex min-h-[58px] flex-col items-center justify-center gap-1 rounded-2xl px-1 py-1 transition-all duration-200 active:scale-95",
                isActive
                  ? "font-extrabold text-[#5B38C2] bg-purple-50"
                  : "font-semibold text-gray-500 hover:text-[#5B38C2] hover:bg-purple-50/50",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <div className={`w-8 h-8 rounded-xl flex items-center justify-center transition-all ${isActive ? "bg-purple-100 shadow-2xs" : ""}`}>
                  <CalendarIcon className={`h-5 w-5 ${isActive ? "text-[#5B38C2]" : "text-gray-500"}`} />
                </div>
                <span className="text-[10px] leading-none tracking-tight">Rotina</span>
              </>
            )}
          </NavLink>

          {/* 3. Evolução */}
          <NavLink
            to="/app/evolution"
            className={({ isActive }) =>
              [
                "relative flex min-h-[58px] flex-col items-center justify-center gap-1 rounded-2xl px-1 py-1 transition-all duration-200 active:scale-95",
                isActive
                  ? "font-extrabold text-[#5B38C2] bg-purple-50"
                  : "font-semibold text-gray-500 hover:text-[#5B38C2] hover:bg-purple-50/50",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <div className={`w-8 h-8 rounded-xl flex items-center justify-center transition-all ${isActive ? "bg-purple-100 shadow-2xs" : ""}`}>
                  <ChartIcon className={`h-5 w-5 ${isActive ? "text-[#5B38C2]" : "text-gray-500"}`} />
                </div>
                <span className="text-[10px] leading-none tracking-tight">Evolução</span>
              </>
            )}
          </NavLink>

          {/* 4. Perfil */}
          <NavLink
            to="/app/profile"
            className={({ isActive }) =>
              [
                "relative flex min-h-[58px] flex-col items-center justify-center gap-1 rounded-2xl px-1 py-1 transition-all duration-200 active:scale-95",
                isActive
                  ? "font-extrabold text-[#5B38C2] bg-purple-50"
                  : "font-semibold text-gray-500 hover:text-[#5B38C2] hover:bg-purple-50/50",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <div className={`w-8 h-8 rounded-xl flex items-center justify-center transition-all ${isActive ? "bg-purple-100 shadow-2xs" : ""}`}>
                  <ProfileIcon className={`h-5 w-5 ${isActive ? "text-[#5B38C2]" : "text-gray-500"}`} />
                </div>
                <span className="text-[10px] leading-none tracking-tight">Perfil</span>
              </>
            )}
          </NavLink>

          {/* 5. MarIA: Ícone Condicional (3 pontinhos na Home vs Foto nas demais telas) */}
          <NavLink
            to="/app/maria-bot"
            className={({ isActive }) =>
              [
                "relative flex min-h-[58px] flex-col items-center justify-center gap-1 rounded-2xl px-1 py-1 transition-all duration-200 active:scale-95 group",
                isActive
                  ? "font-extrabold text-[#5B38C2] bg-purple-50"
                  : "font-semibold text-[#5B38C2] hover:bg-purple-50/50",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <div className="w-8 h-8 rounded-xl bg-gradient-to-tr from-[#5B38C2] to-[#8C6CE8] text-white flex items-center justify-center shadow-sm group-hover:scale-105 transition-transform overflow-hidden">
                    {isHome ? (
                      /* Na Home: Balão de 3 pontinhos */
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                      </svg>
                    ) : (
                      /* Nas demais páginas: Foto oficial da MarIA */
                      <img
                        src={mariaAvatar}
                        alt="MarIA"
                        className="w-full h-full object-cover object-top"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=160&auto=format&fit=crop&q=80";
                        }}
                      />
                    )}
                  </div>
                  <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-400 border-2 border-white rounded-full"></span>
                </div>
                <span className="text-[10px] font-black text-[#5B38C2] leading-none tracking-tight">MarIA</span>
              </>
            )}
          </NavLink>
        </div>
      </div>
    </nav>
  );
}